<template>
  <div class="header-area">
    <el-menu class="navbar" mode="horizontal">
      <hamburger
        class="hamburger-container"
        :toggleClick="toggleSideBar"
        :isActive="sidebar.opened"
      ></hamburger>
      <breadcrumb />
    </el-menu>
    <div class="header-area-message">
      <p>
        评估 <span class="hot">{{ headerState }}</span>
        <span v-if="headerDate">{{ headerDateText }}</span>
        <el-select
          v-if="headerDate"
          class="header-date"
          size="small"
          v-model="headerDate"
          placeholder="请选择基准日期"
          @change="changeHeaderDate"
        >
          <el-option
            v-for="item in headerSelectData"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
        <!-- {{ headerDate }} -->
        {{ stageInfo }}
      </p>
    </div>
    <el-dialog
      title="设置基准日期"
      :visible.sync="headerDateDialogVisible"
      width="300px"
      :show-close="false"
      :close-on-click-modal="false"
    >
      <el-select v-model="headerDate" placeholder="请选择基准日期">
        <el-option
          v-for="item in headerSelectData"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" type="primary" @click="saveHeaderDate"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Breadcrumb from "@/components/Breadcrumb";
import Hamburger from "@/components/Hamburger";
import { Session } from "@/utils/storage";
import * as vueBus from "@/utils/vueBus";
import {
  getHomePageHint,
  findAssessDateListByStatus
} from "@/api/calibrationInfo";

export default {
  components: {
    Breadcrumb,
    Hamburger
  },
  data() {
    return {
      headerState: "未开始",
      headerDateText: "",
      headerDate: "",
      headerSelectData: [],
      stageInfo: "",
      headerDateDialogVisible: false
    };
  },
  computed: {
    ...mapGetters([
      "sidebar",
      "name",
      "assessDate",
      "loginOpenAssessDateStates"
    ])
  },
  mounted() {
    vueBus.$on(vueBus.eventList.getHomePageHint, this.getHomePageHint);
  },
  created() {
    this.getAssessDateList();
  },
  methods: {
    toggleSideBar() {
      this.$store.dispatch("ToggleSideBar");
    },
    changeHeaderDate(val) {
      this.$store.dispatch("SetAssessDate", val);
      window.location.reload();
    },
    saveHeaderDate() {
      this.$store.dispatch("SetAssessDate", this.headerDate);
      this.$store.dispatch("SetLoginOpenAssessDate", false);
      window.location.reload();
    },
    getAssessDateList() {
      findAssessDateListByStatus()
        .then(res => {
          const { code, data } = res;
          if (code == 200) {
            this.headerSelectData = data;
            if (data && data.length > 0) {
              if (data.length == 1) {
                this.headerDate = this.headerSelectData[0].value;
                this.$store.dispatch("SetAssessDate", this.headerDate);
              } else {
                // 设置登录后出现弹窗
                this.headerDateDialogVisible =
                  this.loginOpenAssessDateStates ||
                  Session.get("loginOpenAssessDateStatus");
              }
            } else {
              this.headerDateDialogVisible = false;
            }
          }
        })
        .then(() => {
          this.getHomePageHint();
        });
    },
    getHomePageHint() {
      getHomePageHint().then(response => {
        const { code, data } = response;
        if (code == 200) {
          this.headerState = data.headerState;
          if (data.stageInfo != "") {
            this.stageInfo = "，阶段状态为：" + data.stageInfo;
          }
          if (data.headerDate) {
            this.headerDateText = "，评估基准日为：";
            if (this.headerSelectData.length > 0 && data.headerDate == "null") {
              this.headerDate = this.headerSelectData[0].value;
            } else {
              this.headerDate =
                data.headerDate != "null" ? data.headerDate : "";
            }
            this.$store.dispatch("SetAssessDate", data.headerDate);
          }
        }
      });
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.navbar {
  height: 50px;
  line-height: 50px;
  border-radius: 0px !important;
  .hamburger-container {
    line-height: 58px;
    height: 50px;
    float: left;
    padding: 0 10px;
  }
  .screenfull {
    position: absolute;
    right: 90px;
    top: 16px;
    color: red;
  }
}
.header-date {
  width: 70px;
  font-size: 14px;
  /deep/ .el-input__inner {
    padding: 0;
    border: 0;
    color: #000;
  }
  /deep/ .el-input__prefix,
  /deep/ .el-input__suffix {
    display: none !important;
  }
}
.header-area {
  position: relative;
  .header-area-message {
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
    font-size: 14px;
    .hot {
      color: red;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/layout/components/Navbar.vue